/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-undef */
import { motion } from 'framer-motion';
import React, {
    useState, useCallback, useEffect, useContext,
} from 'react';
import { Link } from 'react-router-dom';
import Pagination from '../../Components/Pagination';
import { PriceHandler } from '../../redux/helper/CamelCase';
import { distributorService } from '../../service/distributor.service';
import InvoiceReportSkeleton from '../MISReports/InvoiceReport/indentReportSkeleton';
import HeaderContext from '../../Components/Context/HeaderContext';
import EmptyScreen from '../../Components/GlobalEmplyPage';
import { AccessPrevilegesFunction } from '../../constants/GlobalAccessFunction';
import ThreeDotsLoader from '../../Components/LoadingDots';

function ManageAdorCash() {
    const viewcashbackprevilegeassigned = AccessPrevilegesFunction('cashback:view');
    const syncAdorCashPrivilageAssigned = AccessPrevilegesFunction('cashback:adjust');
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
    } = useContext(HeaderContext);
    const [adorCashList, setAdorCashList] = useState([]);
    const [syncDisable, setSyncDisable] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setsearchValue] = useState('');
    const [alldata, setalldata] = useState({});
    const [totalPage, setTotalPage] = useState('');
    const [loading, setLoading] = useState(true);
    const [filterModal, setFilterModal] = useState(false);
    const [emptyData, setEmptyData] = useState(false);
    const [sortType, setsortType] = useState('opening_balance+asc');
    const [filterValue, setfilterValue] = useState('');
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');
    const disableDuration = 5 * 60 * 1000; // 5 minutes in milliseconds
    const disabledKey = 'buttonDisabledUntil';

    useEffect(() => {
        const disableUntil = localStorage.getItem(disabledKey);
        if (disableUntil) {
            const currentTime = new Date().getTime();
            if (currentTime < Number(disableUntil)) {
                setSyncDisable(true);
            } else {
                localStorage.removeItem(disabledKey); // Clear the stored timestamp if it has expired
            }
        }
    }, []);

    const handleAdorCashList = useCallback((() => {
        distributorService.AdorCashList(currentPage, sortType, searchValue, filterValue).then((response) => {
            if (response.error === false && response.data.data.success_status === true) {
                if (response.data.data.Items.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setLoading(false);
                setAdorCashList(response.data.data.Items);
                setCurrentPage(response.data.data.current_page);
                setTotalPage(response.data.data.number_of_pages);
            } else {
                setLoading(false);
            }
        });
    }), [currentPage, searchValue, sortType, filterValue]);

    const handlePageClick = async (data) => {
        setLoading(false);
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleSync = async () => {
        setSyncDisable(true);
        distributorService.AdorCashSync().then((val) => {
            if (val.data.success_status) {
                // setshowPopup(true);
                SetSuccessMessage('Transaction Sync in Progress. Your data will be synched soon.');
                setTimeout(() => {
                    // settitle('');
                    SetSuccessMessage('');
                }, 2000);
            }
        });
        const disableUntil = new Date().getTime() + disableDuration;
        localStorage.setItem(disabledKey, disableUntil);
        setTimeout(() => {
            setSyncDisable(false);
            localStorage.removeItem(disabledKey);
        }, disableDuration);
    };

    const handleExport = useCallback((() => {
        distributorService.AdorCashList(currentPage, sortType, searchValue, filterValue, exportSelected).then((val) => {
            if (val.data.data.success_status) {
                // setshowPopup(true);
                SetSuccessMessage('Files exported Successfully!');
                setexportClick(false);
                setexportSelected('');
                window.open(val.data.data.url, '_blank');
                setTimeout(() => {
                    // settitle('');
                    SetSuccessMessage('');
                }, 2000);
            }
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    useEffect(() => {
        handleAdorCashList();
        handleAdorCashList();
    }, [handleAdorCashList]);

    return (
        <div className="py-6 pr-[18px] main-screen">
            <div className="flex justify-between pb-[18px]">
                <h5 className="text-xs4 font-normal text-[#090406]">Ador Cash Management</h5>
                <div className="flex">
                    <div className="relative">
                        <label htmlFor="search" />
                        <input
                            type="text"
                            name="search"
                            id="search"
                            className="w-[235px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]"
                            placeholder="Search"
                            onChange={(e) => {
                                setsearchValue(e.target.value);
                                setCurrentPage(1);
                            }}
                            autoComplete="off"
                        />
                        <img src="images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px]" />
                    </div>
                    {syncAdorCashPrivilageAssigned && (
                        <div className="pl-2 relative">
                            <button
                                type="button"
                                id="syncDropdown"
                                disabled={syncDisable}
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                style={syncDisable ? { backgroundColor: '#44445E' } : {}}
                                className={`dropdown-toggle h-[35px] text-xs2 font-semibold ${syncDisable ? 'text-[#44445E] border-[#FFFFFF]' : 'text-[#555259] border-[#555259]'} px-9 border rounded-lg`}
                                onClick={() => !syncDisable && handleSync()}
                            >
                                {syncDisable ? <ThreeDotsLoader /> : 'Sync'}
                            </button>
                        </div>
                    )}
                    <div className="pl-2 dropdown relative">
                        <button
                            type="button"
                            id="exportDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] px-9 border border-[#555259] rounded-lg"
                            onClick={() => setexportClick(!exportClick)}
                        >
                            Export
                        </button>
                        <ul className={`dropdown-menu min-w-[111px]  ${exportClick === true ? 'show' : 'hidden'} absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999]`} aria-labelledby="exportDropdown">
                            <li className="mx-[18px] pb-1.5 mt-5 hover:bg-[#F2F2F3] hover:rounded export">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => {
                                        setexportSelected('csv');
                                    }}
                                >
                                    CSV

                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('pdf')}
                                >
                                    PDF

                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 mb-3 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('excel')}
                                >
                                    Excel

                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {loading ? <InvoiceReportSkeleton /> : (
                <div>
                    {adorCashList.length > 0 && (
                        <div
                            className="overflow-auto dropdown-menu pb-7 relative"
                            style={{ height: 'calc(100vh - 298px)', zIndex: '9' }}
                        >
                            <table className="w-full table-auto relative">
                                <thead className="sticky top-0 left-0 z-[2]">
                                    <tr className="bg-[#555259] h-10">
                                        <th className="py-2.5 px-6 rounded-bl-lg rounded-tl-lg min-w-[171px] bg-[#555259]" scope="col">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-start">
                                                Distributor Code
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                Distributor Name
                                                <a href="#" className="pl-[5px]">
                                                    <motion.img
                                                        animate={{ rotate: sortType === 'distributor_name+asc' ? 180 : 0 }}
                                                        className={`${sortType === 'distributor_name+desc' ? 'image-rotate' : ''}`}
                                                        src="/images/sort.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            if (sortType === 'distributor_name+asc') {
                                                                setsortType('distributor_name+desc');
                                                            } else if (sortType === 'distributor_name+desc') {
                                                                setsortType('distributor_name+asc');
                                                            } else {
                                                                setsortType('distributor_name+asc');
                                                            }
                                                            // setCurrentPage(1);
                                                            // setisLoaded(true);
                                                        }}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[100px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Type
                                                <a href="#" className="pl-[5px]">
                                                    <motion.img
                                                        animate={{ rotate: sortType === 'distributor_type+asc' ? 180 : 0 }}
                                                        className={`${sortType === 'distributor_type+desc' ? 'image-rotate' : ''}`}
                                                        src="/images/sort.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            if (sortType === 'distributor_type+asc') {
                                                                setsortType('distributor_type+desc');
                                                            } else if (sortType === 'distributor_type+desc') {
                                                                setsortType('distributor_type+asc');
                                                            } else {
                                                                setsortType('distributor_type+asc');
                                                            }
                                                            // setCurrentPage(1);
                                                            // setisLoaded(true);
                                                        }}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[177px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-end">
                                                Opening Balance
                                                <a href="#" className="pl-[5px]">
                                                    <motion.img
                                                        animate={{ rotate: sortType === 'opening_balance+asc' ? 180 : 0 }}
                                                        className={`${sortType === 'opening_balance+desc' ? 'image-rotate' : ''}`}
                                                        src="/images/sort.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            if (sortType === 'opening_balance+asc') {
                                                                setsortType('opening_balance+desc');
                                                            } else if (sortType === 'opening_balance+desc') {
                                                                setsortType('opening_balance+asc');
                                                            } else {
                                                                setsortType('opening_balance+asc');
                                                            }
                                                            // setCurrentPage(1);
                                                            // setisLoaded(true);
                                                        }}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 rounded-tr-lg rounded-br-lg min-w-[100px] sticky top-0 right-0 bg-[#555259]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                Action
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {adorCashList.length > 0 && adorCashList.map((item) => (
                                        <tr className="bg-[#FDFDFE] border-b border-[#DFEAF7]">
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 sticky left-0 bg-[#ffffffe6] z-[1]">
                                                {item?.distributor_id}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                                {item?.distributor_name}
                                            </td>
                                            <td className="text-center text-sm font-normal text-[#090406] py-2.5 px-7">
                                                {item?.distributor_type}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-end">
                                                {PriceHandler(item?.opening_balance)}
                                            </td>
                                            {viewcashbackprevilegeassigned
                                            && (
                                                <td className="text-xs font-normal py-2.5 px-7 text-center flex justify-start">
                                                    <Link to={`/ador-cash-management/${item.distributor_id}/view`} className="rounded px-2.5 py-[5px] bg-[#44445E] w-fit text-xs font-normal text-[#FFFFFF]">
                                                        View
                                                    </Link>
                                                </td>
                                            ) }
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                    {!loading && adorCashList && adorCashList.length > 0 && (
                        <Pagination
                            handlePageClick={handlePageClick}
                            totalPage={totalPage}
                            List={alldata}
                            currentPage={currentPage}
                        />
                    )}
                    {emptyData && (
                        <EmptyScreen
                            search="yes"
                            text="no Ador Cash Transactions"
                            buttonRequired={false}
                            all={searchValue.length > 0 ? 'under searched term' : 'found'}
                        />
                    )}

                </div>
            )}

        </div>
    );
}

export default ManageAdorCash;
